module.exports = __webpack_public_path__ + "img/SharingDocuments01.2d361096.svg";